function NavBar() {
  return (
    <div className="py-6">
      <img src="/images/logo.png" width="160" />
    </div>
  );
}

export default NavBar;
